module.exports = __webpack_public_path__ + "thumbnail.351d578b.webp";